
export class AgreementService {
	agreementServiceId: number;
	serviceId: number;
	serviceCategoryId: number;
	serviceTypeId: number;
	hasRequestServices: boolean;
}
